const SWIPE_THRESHOLD = 50;
const AUTO_SLIDE_DELAY = 8000;

function loadSlideImages(slide) {
  if (!slide) return;

  const lazyImages = slide.querySelectorAll('img[data-src]');
  lazyImages.forEach((img) => {
    const dataSrc = img.getAttribute('data-src');
    if (dataSrc) {
      img.setAttribute('src', dataSrc);
      img.removeAttribute('data-src');
    }
  });
}

function initSlideshow(container) {
  if (!container || container.dataset.elSlideshowInit === 'true') return;
  container.dataset.elSlideshowInit = 'true';

  const slides = Array.from(container.querySelectorAll('.slide'));
  if (!slides.length) return;

  let currentSlide = slides.findIndex((slide) => slide.classList.contains('active'));
  if (currentSlide < 0) currentSlide = 0;

  let slideInterval = null;

  const showSlide = (index) => {
    slides.forEach((slide, i) => {
      const textBox = slide.querySelector('.slide-text.text-box');

      if (i === index) {
        slide.classList.add('active');
        slide.classList.remove('inactive');
        if (textBox) textBox.classList.add('js-animation-done');
        loadSlideImages(slide);
      } else {
        slide.classList.remove('active');
        slide.classList.add('inactive');
        if (textBox) textBox.classList.remove('js-animation-done');
      }
    });
  };

  const startSlideInterval = () => {
    if (slideInterval) {
      clearInterval(slideInterval);
    }

    slideInterval = setInterval(() => changeSlide(1, false), AUTO_SLIDE_DELAY);
  };

  const pauseSlideInterval = () => {
    if (slideInterval) {
      clearInterval(slideInterval);
      slideInterval = null;
    }
  };

  const changeSlide = (delta, shouldRestart = true) => {
    currentSlide = (currentSlide + delta + slides.length) % slides.length;
    showSlide(currentSlide);

    if (shouldRestart) {
      startSlideInterval();
    }
  };

  showSlide(currentSlide);
  startSlideInterval();

  container.querySelectorAll('.slide-btn').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      event.preventDefault();

      // stop auto sliding when the user manually interacts
      pauseSlideInterval();

      const direction = btn.dataset.direction;

      if (direction === 'next') {
        changeSlide(1, false);
      } else if (direction === 'prev') {
        changeSlide(-1, false);
      }
    });
  });

  // ---vv--- To make the slideshow swipe-able for Mobile ---vv--- //
  const slideshowElement = container.querySelector('.slideshow');

  if (slideshowElement) {
    let touchStartX = 0;
    let touchStartY = 0;

    slideshowElement.addEventListener(
      'touchstart',
      (event) => {
        const touch = event.changedTouches[0];

        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
      },
      { passive: true }
    );

    slideshowElement.addEventListener(
      'touchend',
      (event) => {
        const touch = event.changedTouches[0];

        const touchEndX = touch.clientX;
        const touchEndY = touch.clientY;
        const deltaX = touchEndX - touchStartX;
        const deltaY = touchEndY - touchStartY;

        if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > SWIPE_THRESHOLD) {
          pauseSlideInterval();
          changeSlide(deltaX < 0 ? 1 : -1, false);
        }
      },
      { passive: true }
    );
  }
}

function initSlideshows() {
  document.querySelectorAll('.slideshow-outer-ctr').forEach((container) => {
    initSlideshow(container);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initSlideshows);
} else {
  initSlideshows();
}

document.addEventListener('shopify:section:load', initSlideshows);
window.addEventListener('pageshow', initSlideshows);
